import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import { useStyles } from "./Styles";

const propTypes = {
  children: PropTypes.object.isRequired,
};

Container.prototype = propTypes;

export default function Container(props) {
  const styles = useStyles();
  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="start" spacing={2}>
      <Grid item xs={12}>
        {props.children}
      </Grid>
    </Grid>
  );
}
